import * as Style from "./styles";
import "./styles.css"
import { Form, Row, Col } from "../../components/Form";
// --- ALTERADO --- (Adicionado 'Spin' para o loading do botão)
import { message, Card, Result, Modal, Spin } from "antd";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Fieldset } from "../../components/Fieldset";
import { useParams, useNavigate } from "react-router-dom";
import { Input } from "../../components/Input";
import { Button } from "../../components/Button";
import { SelectLabel } from "../../components/SelectLabel";
import * as Yup from "yup";
import { User } from "../../control/user/control-user";
import { InputMask } from "../../components/InputMask";
import { Lead } from "../../control/lead/control-lead";
import { Estado } from "../../control/estado/control-estado";
import { Cidade } from "../../control/cidade/control-cidade";
import React, { useEffect, useState } from "react";

import useAuth from "../../hooks/useAuth";
import { InputCheck } from "../../components/InputCheck";
import { Loading } from "../../components/Loading";
import { Lojista } from "../../control/lojista/control-lojista"; // Mantido do seu script original

const { Meta } = Card;
const schema = Yup.object().shape({
  name: Yup.string().required("Campo nome é obrigatório."),
  // ... (resto do seu schema original) ...
  telefone: Yup.string().required("Campo telefone é obrigatório."),
  politica: Yup.boolean()
    .oneOf([true], 'Você deve concordar com a Política de Privacidade')
    .required('Você deve concordar com a Política de Privacidade'),
  idestado: Yup.string().required("Campo Estado é obrigatório."),
  idcidade: Yup.string().required("Campo Cidade é obrigatório."),
  dtnascimento: Yup.string().required("Campo Data Nascimeto é obrigatório."),
});

export const CadastroLeadResumido = ({ layout }) => {
  // --- ALTERADO --- (Adicionadas as novas funções do hook)
  const {
    sideIn,
    sideOut,
    requestPhoneValidationCode,
    verifyPhoneValidationCode
  } = useAuth();

  const navigate = useNavigate();
  const { produto = null, idlote } = layout?.lote || {};
  const { hash = null, } = layout || {};
  const [estado, setEstado] = useState();
  const [cidade, setCidade] = useState();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [registeredEmail, setRegisteredEmail] = useState();
  const [registeredSenha, setRegisteredSenha] = useState();
  const [loading, setLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();

  // --- ALTERADO --- (Adicionado 'watch')
  const { register, handleSubmit, formState, control, reset, watch } = useForm({
    mode: "onBlur",
    resolver: yupResolver(schema),
    defaultValues: {
      idpais: 1,
      email: "multleads" + Date.now() + "@gmail.com",
      password: "",
      name: "",
      idperfil: 3,
      status: "A",
      idacesso: layout?.idacesso,
      fone: "",
    },
  });
  const { errors, isSubmitting } = formState;

  // --- NOVO --- (Estados para controlar o fluxo de validação)
  const [phoneCode, setPhoneCode] = useState("");
  const [phoneValidationStep, setPhoneValidationStep] = useState('idle'); // 'idle', 'pending', 'verified'
  const [validationError, setValidationError] = useState("");
  const [validationLoading, setValidationLoading] = useState(false);

  // --- NOVO --- (Observa o campo de telefone)
  const userPhone = watch("telefone");

  useEffect(() => {
    getEstado().then((data) => {
      setEstado(data);
    });
    sideIn(process.env.REACT_APP_EMAIL_GLOBAL, process.env.REACT_APP_PASSWORD_GLOBAL);
  }, []);

  // --- NOVO --- (useEffect para monitorar mudança no telefone)
  useEffect(() => {
    // Se o usuário mudar o número, reseta a validação
    if (phoneValidationStep !== 'idle' && userPhone) {
      setPhoneValidationStep('idle');
      setPhoneCode("");
      setValidationError("O número de telefone mudou. Por favor, valide-o novamente.");
    }
  }, [userPhone]); // Dependência: userPhone (do watch)

  // --- Funções existentes (sem alteração) ---
  const gerarSenhaDefault = () => {
    const timestamp = Date.now().toString();
    const parteAleatoria = timestamp.slice(-6);
    return `mudar${parteAleatoria}`;
  };
  const getEstado = async () => {
    const EstadoData = await Estado.listCombo();
    if (EstadoData?.status && EstadoData.status === 200 && EstadoData.data) {
      return EstadoData.arrayEstado;
    }
  };
  const getCity = async (state) => {
    const CityData = await Cidade.getAllCity(state);
    if (CityData?.status && CityData.status === 200 && CityData.data) {
      setCidade(() => CityData.arrayCity)
    }
    // setEstadoLojista(state)
  };
  const showModal = () => {
    setIsModalOpen((open) => !open);
  };
  const userRegisteredEmail = async () => {
    if (!registeredEmail) {
      return
    }
    setLoading(true)
    const login = await sideIn(registeredEmail, registeredSenha);
    if (login) {
      setLoading(false)
      message.error(`Usuário não encontrado.`, 2);
      return
    }
    const data = {
      email: registeredEmail,
      hash
    }
    const result = await Lead.addBondLead(data);
    if (result.status && (result?.status === 200 || result?.status === 201) && result.data.message != 'erro') {
      if (produto.editatemplate === 1 && produto.idconfigproduto == 1) {
        message.success("Cadastrado com sucesso.", 2, navigate(`/home/template/${idlote}/${hash}`));
      } else {
        message.success("Cadastrado com sucesso.", 2, navigate(0));
      }
    } else {
      message.error(`"Não foi possivel efetuar cadastro." ${result.data.error}`, 2);
      setLoading(false)
    }
  };
  const redirectPage = (user) => {
    if (produto.editatemplate === 1 && produto.idconfigproduto == 1) {
      sideOut()
      setTimeout(() => {
        navigate(`/`)
      }, 700)
    } else {
      navigate(0)
    }
  };

  // --- NOVO --- (Handler para pedir o código de validação)
  const handleRequestValidationCode = async () => {
    const rawPhone = userPhone?.replace(/\D/g, ""); // Limpa a máscara
    if (!rawPhone || rawPhone.length < 10) {
      setValidationError("Preencha um telefone válido (com DDD)");
      return;
    }
    setValidationLoading(true);
    setValidationError("");

    const result = await requestPhoneValidationCode(rawPhone);
    setValidationLoading(false);

    if (result && result.success) {
      setPhoneValidationStep('pending');
      message.success("Código enviado para o seu WhatsApp!");
    } else {
      setValidationError(result.message || "Erro ao enviar código. Tente novamente.");
    }
  };

  // --- NOVO --- (Handler para verificar o código)
  const handleVerifyValidationCode = async () => {
    const rawPhone = userPhone?.replace(/\D/g, "");
    if (!rawPhone || !phoneCode) {
      setValidationError("Preencha o código recebido");
      return;
    }
    setValidationLoading(true);
    setValidationError("");

    const result = await verifyPhoneValidationCode(rawPhone, phoneCode);
    setValidationLoading(false);

    if (result && result.success) {
      setPhoneValidationStep('verified');
      setValidationError("");
      message.success("Telefone validado com sucesso!");
    } else {
      setValidationError(result.message || "Código inválido ou expirado.");
    }
  };

  // --- handleSubmitData (Função principal) ---
  const handleSubmitData = async (data, event) => {
    event.preventDefault();

    // --- NOVO --- (Trava de segurança)
    if (phoneValidationStep !== 'verified') {
      setValidationError("Você precisa validar seu número de telefone antes de salvar.");
      message.error("Valide seu telefone para continuar.");
      return;
    }
    // --- FIM NOVO ---

    console.log("data", data);

    try {
      setLoading(true);
      await sideIn(process.env.REACT_APP_EMAIL_GLOBAL, process.env.REACT_APP_PASSWORD_GLOBAL);

      const idestado = data.idestado != undefined ? parseInt(data.idestado) : 16
      const idcidade = data.idcidade != undefined ? parseInt(data.idcidade) : 2836
      const idlojista = data.idlojista ? parseInt(data.idlojista) : undefined
      const dtnascimento = data.dtnascimento != undefined ? new Date(data.dtnascimento.split("/").reverse().join("-")) : new Date('1900-01-01')
      const fone = data.telefone.replace(/\D/g, "")
      const password = gerarSenhaDefault();

      const dataSend = {
        // ... (seu objeto dataSend original) ...
        hash,
        email: data.email,
        name: data.name,
        password: password,
        idperfil: 3,
        status: "A",
        fone: fone,
        lead: {
          idpais: 1,
          idestado: idestado,
          idcidade: idcidade,
          idacesso: parseInt(data.idacesso),
          idlojista: idlojista,
          nome: data.name,
          telefone: data.telefone,
          dtnascimento: dtnascimento,
          email: data.email,
        }
      };

      const result = await User.addUserLead(dataSend);

      if (result.status && (result?.status === 200 || result?.status === 201) && result.data.message !== 'erro') {
        message.success("Usuário cadastrado com sucesso.", 2, redirectPage(data));
      } else {
        message.error(`Não foi possível efetuar cadastro. ${result.data.error}`, 2);
      }
    } catch (error) {
      console.error("Erro ao salvar usuário:", error);
      message.error("Ocorreu um erro ao salvar usuário. Por favor, tente novamente.", 2);
    } finally {
      setLoading(false);
    }
  };

  // --- Início do JSX ---
  return (
    <Style.Content>
      <Loading loading={loading} />
      {contextHolder}
      <Style.Header>
        {produto.imagem && <Style.Logo src={produto.imagem} alt="logo" />}
        {(produto.configimagembaner && produto.configimagembaner != 'null') && <Style.ImgBanner src={produto.configimagembaner} alt="banner" />}
      </Style.Header>
      <Form onSubmit={handleSubmit(handleSubmitData)}>
        <Fieldset title={"Cadastro"} overflow="hidden">
          <Style.linkCadastro onClick={() => showModal()}>Já tenho Cadastro</Style.linkCadastro>
          <Modal style={{ padding: 1 }} title="Sou cadastrado" open={isModalOpen} onCancel={() => showModal()} footer={<Button onClick={() => userRegisteredEmail()}>Usar Cadastro</Button>}  >
          </Modal>
          <Row>
            <Col column="col-md-4">
              <Input
                register={register("name")}
                text="Nome"
                type="text"
                error={errors?.name?.message}
              />
            </Col>
            <Col column="col-md-2">
              <InputMask
                mask={"99/99/9999"}
                placeholder={"Data de nascimanto"}
                register={register("dtnascimento")}
                text="Data de nascimanto"
                type="text"
                error={errors?.dtnascimento?.message}
              />
            </Col>
          </Row>

          <Row style={{ marginBottom: "10px" }}>
            <Col column="col-md-4">
              <InputMask
                mask={"(99)99999-9999"}
                register={register("telefone")}
                text="Telefone"
                type="text"
                error={errors?.telefone?.message}
                disabled={phoneValidationStep === 'pending'}
              />
            </Col>
          </Row>

          {/* Área de validação do telefone */}
          <Row>
            <Col column="col-md-6">

              {/* ETAPA 1 — Solicitar validação */}
              {phoneValidationStep === 'idle' && (
                <Button
                  onClick={handleRequestValidationCode}
                  disabled={validationLoading || !userPhone || !!errors?.telefone}
                  type="button"
                  style={{ width: "100%", marginTop: "8px" }}
                >
                  {validationLoading ? <Spin size="small" /> : "Validar Telefone"}
                </Button>
              )}

              {/* ETAPA 2 — Código + Botões (CORRIGIDO) */}
              {phoneValidationStep === 'pending' && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-end",
                    gap: "20px",
                    marginTop: "10px",
                    flexWrap: "wrap"
                  }}
                >
                  {/* Campo do código */}
                  <div style={{ width: "180px" }}>
                    <Input
                      text="Código WhatsApp"
                      placeholder="Código"
                      value={phoneCode}
                      onChange={(e) => [setPhoneCode(e.target.value), setValidationError("")]}
                    />
                  </div>

                  {/* Botões lado a lado */}
                  <div
                    style={{
                      display: "flex",
                      gap: "10px",
                      flexShrink: 0
                    }}
                  >
                    <Button
                      onClick={handleVerifyValidationCode}
                      disabled={validationLoading || !phoneCode}
                      type="button"
                      style={{ width: "140px" }}
                    >
                      {validationLoading ? <Spin size="small" /> : "Confirmar"}
                    </Button>

                    <Button
                      onClick={() => {
                        setPhoneValidationStep('idle');
                        setValidationError("");
                        setPhoneCode("");
                      }}
                      disabled={validationLoading}
                      type="button"
                      style={{
                        background: '#666',
                        color: '#fff',
                        width: "140px"
                      }}
                    >
                      Trocar Nº
                    </Button>
                  </div>
                </div>
              )}

              {/* ETAPA 3 — Sucesso */}
              {phoneValidationStep === 'verified' && (
                <div
                  style={{
                    color: 'green',
                    fontWeight: 'bold',
                    paddingTop: '12px',
                    fontSize: '0.95em'
                  }}
                >
                  ✓ Telefone validado com sucesso!
                </div>
              )}

              {/* Erro */}
              {validationError && (
                <div
                  style={{
                    color: 'red',
                    marginTop: '6px',
                    fontSize: '0.85em'
                  }}
                >
                  {validationError}
                </div>
              )}

            </Col>
          </Row>


          <Row>
            <Col column="col-md-2">
              <Controller
                control={control}
                name="idestado"
                render={({ field }) => (
                  <SelectLabel
                    // ... (props do SelectLabel original) ...
                    field={field}
                    text="Estado"
                    error={errors?.idestado?.message}
                    options={estado}
                    onChange={(value, date) => {
                      field.onChange(value);
                      getCity(value)
                    }}
                  />
                )}
              />
            </Col>
            <Col column="col-md-2">
              <Controller
                control={control}
                name="idcidade"
                render={({ field }) => (
                  <SelectLabel
                    // ... (props do SelectLabel original) ...
                    field={field}
                    text="Cidade"
                    error={errors?.idcidade?.message}
                    register={register("idcidade")}
                    options={cidade}
                    onChange={(value, date) => {
                      field.onChange(value);
                      // getLojista(value)
                    }}
                  />
                )}
              />
            </Col>
          </Row>
          <Row>
            <Col column="col-md-4">
              <InputCheck register={register("politica")} error={errors?.politica?.message}>
                Li e concordo com a <Style.linkPoliticy href="https://4bi-diogo.s3.us-east-2.amazonaws.com/Politica+de+Privacidade/POLÍTICA+DE+PRIVACIDADE.pdf" target="_blank">Política de privacidade</Style.linkPoliticy>
              </InputCheck>
            </Col>
          </Row>
        </Fieldset>
        <Style.Actions>
          {/* --- ALTERADO --- (Botão Salvar com validação) */}
          <Button
            type="submit"
            disabled={isSubmitting || phoneValidationStep !== 'verified'}
          >
            Salvar
          </Button>
        </Style.Actions>
      </Form>
    </Style.Content>
  );
};


// import * as Style from "./styles";
// import "./styles.css"
// import { Form, Row, Col } from "../../components/Form";
// import { message, Card, Result, Modal } from "antd";
// import { useForm, Controller } from "react-hook-form";
// import { yupResolver } from "@hookform/resolvers/yup";
// import { Fieldset } from "../../components/Fieldset";
// import { useParams, useNavigate } from "react-router-dom";
// import { Input } from "../../components/Input";
// import { Button } from "../../components/Button";
// import { SelectLabel } from "../../components/SelectLabel";
// import * as Yup from "yup";
// import { User } from "../../control/user/control-user";
// import { InputMask } from "../../components/InputMask";
// import { Lead } from "../../control/lead/control-lead";
// import { Estado } from "../../control/estado/control-estado";
// import { Cidade } from "../../control/cidade/control-cidade";
// import React, { useEffect, useState } from "react";

// import useAuth from "../../hooks/useAuth";
// import { InputCheck } from "../../components/InputCheck";
// import { Loading } from "../../components/Loading";
// import { Lojista } from "../../control/lojista/control-lojista";

// const { Meta } = Card;
// const schema = Yup.object().shape({
//   name: Yup.string().required("Campo nome é obrigatório."),
//   // email: Yup.string().required("Campo Email é obrigatório.")
//   //   .required("Campo Email Confirmação é obrigatório.")
//   //   .oneOf([Yup.ref("email")], "Existem divergências entre os e-mails."),
//   telefone: Yup.string().required("Campo telefone é obrigatório."),
//   politica: Yup.boolean()
//     .oneOf([true], 'Você deve concordar com a Política de Privacidade')
//     .required('Você deve concordar com a Política de Privacidade'),
//   idestado: Yup.string().required("Campo Estado é obrigatório."),
//   idcidade: Yup.string().required("Campo Cidade é obrigatório."),
//   dtnascimento: Yup.string().required("Campo Data Nascimeto é obrigatório."),
//   // password: Yup.string().required("Campo Senha é obrigatório."),
//   // senhaConfimar: Yup.string()
//   //   .required("Senha Confirmação.")
//   //   .oneOf([Yup.ref("password")], "Senha precisa ser igual."),
// });

// export const CadastroLeadResumido = ({ layout }) => {
//   const { sideIn, sideOut } = useAuth();
//   const navigate = useNavigate();
//   const { produto = null, idlote } = layout?.lote || {};
//   const { hash = null, } = layout || {};
//   const [estado, setEstado] = useState();
//   const [cidade, setCidade] = useState();
//   // const [lojista, setLojista] = useState([]);
//   // const [estadoLojista, setEstadoLojista] = useState();
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [registeredEmail, setRegisteredEmail] = useState();
//   const [registeredSenha, setRegisteredSenha] = useState();
//   const [loading, setLoading] = useState(false);
//   const [messageApi, contextHolder] = message.useMessage();
//   const { register, handleSubmit, formState, control, reset } = useForm({
//     mode: "onBlur",
//     resolver: yupResolver(schema),
//     defaultValues: {
//       idpais: 1,
//       email: "multleads" + Date.now() + "@gmail.com",
//       password: "",
//       name: "",
//       idperfil: 3,
//       status: "A",
//       idacesso: layout?.idacesso,
//       fone: "",
//     },
//   });
//   useEffect(() => {

//     getEstado().then((data) => {
//       setEstado(data);
//     });

//     sideIn(process.env.REACT_APP_EMAIL_GLOBAL, process.env.REACT_APP_PASSWORD_GLOBAL);

//   }, []);

//   const gerarSenhaDefault = () => {
//     const timestamp = Date.now().toString();
//     const parteAleatoria = timestamp.slice(-6);
//     return `mudar${parteAleatoria}`;
//   };

//   const getEstado = async () => {
//     const EstadoData = await Estado.listCombo();
//     if (EstadoData?.status && EstadoData.status === 200 && EstadoData.data) {
//       return EstadoData.arrayEstado;
//     }
//   };

//   const getCity = async (state) => {
//     const CityData = await Cidade.getAllCity(state);
//     if (CityData?.status && CityData.status === 200 && CityData.data) {
//       setCidade(() => CityData.arrayCity)
//     }
//     // setEstadoLojista(state)
//   };

//   // const getLojista = async (cidade) => {
//   //   const LojistaData = await Lojista.listCombo(estadoLojista, cidade, layout.lote.produto.idempresa);
//   //   if (LojistaData?.status && LojistaData.status === 200 && LojistaData.data) {
//   //     setLojista(()=>LojistaData.arrayLojista)
//   //     console.log(lojista)
//   //   }
//   // };

//   const showModal = () => {
//     setIsModalOpen((open) => !open);
//   };

//   const userRegisteredEmail = async () => {
//     if (!registeredEmail) {
//       return
//     }
//     setLoading(true)
//     const login = await sideIn(registeredEmail, registeredSenha);
//     if (login) {
//       setLoading(false)
//       message.error(`Usuário não encontrado.`, 2);
//       return
//     }
//     const data = {
//       email: registeredEmail,
//       hash
//     }
//     const result = await Lead.addBondLead(data);
//     if (result.status && (result?.status === 200 || result?.status === 201) && result.data.message != 'erro') {
//       if (produto.editatemplate === 1 && produto.idconfigproduto == 1) {
//         message.success("Cadastrado com sucesso.", 2, navigate(`/home/template/${idlote}/${hash}`));
//       } else {
//         message.success("Cadastrado com sucesso.", 2, navigate(0));
//       }
//     } else {
//       message.error(`"Não foi possivel efetuar cadastro." ${result.data.error}`, 2);
//       setLoading(false)
//     }
//   };

//   const { errors, isSubmitting } = formState;

//   const handleSubmitData = async (data, event) => {
//     event.preventDefault(); // Previne o comportamento padrão de submissão do formulário

//     console.log("data", data);

//     try {
//       setLoading(true);

//       // Realiza o login antes de enviar os dados do usuário, se necessário
//       await sideIn(process.env.REACT_APP_EMAIL_GLOBAL, process.env.REACT_APP_PASSWORD_GLOBAL);

//       const idestado = data.idestado != undefined ? parseInt(data.idestado) : 16
//       const idcidade = data.idcidade != undefined ? parseInt(data.idcidade) : 2836
//       const idlojista = data.idlojista ? parseInt(data.idlojista) : undefined
//       const dtnascimento = data.dtnascimento != undefined ? new Date(data.dtnascimento.split("/").reverse().join("-")) : new Date('1900-01-01')
//       const fone = data.telefone.replace(/\D/g, "")
//       const password = gerarSenhaDefault();

//       const dataSend = {
//         hash,
//         email: data.email,
//         name: data.name,
//         password: password,
//         idperfil: 3,
//         status: "A",
//         fone: fone,
//         lead: {
//           idpais: 1,
//           idestado: idestado,
//           idcidade: idcidade,
//           idacesso: parseInt(data.idacesso),
//           idlojista: idlojista,
//           nome: data.name,
//           telefone: data.telefone,
//           dtnascimento: dtnascimento,
//           email: data.email,
//         }
//       };

//       // Salva o usuário
//       const result = await User.addUserLead(dataSend);

//       if (result.status && (result?.status === 200 || result?.status === 201) && result.data.message !== 'erro') {
//         // Exibe mensagem de sucesso e redireciona o usuário
//         message.success("Usuário cadastrado com sucesso.", 2, redirectPage(data));
//       } else {
//         // Exibe mensagem de erro
//         message.error(`Não foi possível efetuar cadastro. ${result.data.error}`, 2);
//       }
//     } catch (error) {
//       console.error("Erro ao salvar usuário:", error);
//       // Exibe mensagem de erro genérica
//       message.error("Ocorreu um erro ao salvar usuário. Por favor, tente novamente.", 2);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const redirectPage = (user) => {
//     if(produto.editatemplate === 1 && produto.idconfigproduto == 1){
//       sideOut()
//       setTimeout(()=>{
//         navigate(`/`)
//       }, 700)
//     }else{
//       navigate(0)
//     }
//   };

//   return (
//     <Style.Content>
//       <Loading loading={loading} />
//       {contextHolder}
//       <Style.Header>
//         {produto.imagem && <Style.Logo src={produto.imagem} alt="logo" />}
//         {(produto.configimagembaner && produto.configimagembaner != 'null') && <Style.ImgBanner src={produto.configimagembaner} alt="banner" />}
//       </Style.Header>
//       <Form onSubmit={handleSubmit(handleSubmitData)}>
//         <Fieldset title={"Cadastro"} overflow="hidden">
//           <Style.linkCadastro onClick={() => showModal()}>Já tenho Cadastro</Style.linkCadastro>
//           <Modal style={{ padding: 1 }} title="Sou cadastrado" open={isModalOpen} onCancel={() => showModal()} footer={<Button onClick={() => userRegisteredEmail()}>Usar Cadastro</Button>}  >
//             <Row>
//               <Col column="col-md-6">
//                 <Input
//                   onChange={(value) => setRegisteredEmail(value.target.value)}
//                   text="E-mail cadastrado"
//                   placeholder="E-mail"
//                   type="text"
//                 />
//               </Col>
//               <Col column="col-md-6">
//                 <Input
//                   onChange={(value) => setRegisteredSenha(value.target.value)}
//                   text="Senha"
//                   placeholder="Senha"
//                   type="password"
//                 />
//               </Col>
//             </Row>
//           </Modal>
//           <Row>
//             <Col column="col-md-4">
//               <Input
//                 register={register("name")}
//                 text="Nome"
//                 type="text"
//                 error={errors?.name?.message}
//               />
//             </Col>
//             <Col column="col-md-2">
//               <InputMask
//                 mask={"99/99/9999"}
//                 placeholder={"Data de nascimanto"}
//                 register={register("dtnascimento")}
//                 text="Data de nascimanto"
//                 type="text"
//                 error={errors?.dtnascimento?.message}
//               />
//             </Col>
//           </Row>
//           <Row>
//             <Col column="col-md-4">
//               <InputMask
//                 mask={"(99)99999-9999"}
//                 register={register("telefone")}
//                 text="Telefone"
//                 type="text"
//                 error={errors?.telefone?.message}
//               />
//             </Col>
//           </Row>
//           <Row>
//             <Col column="col-md-2">
//               <Controller
//                 control={control}
//                 name="idestado"
//                 render={({ field }) => (
//                   <SelectLabel
//                     field={field}
//                     text="Estado"
//                     error={errors?.idestado?.message}
//                     options={estado}
//                     onChange={(value, date) => {
//                       field.onChange(value);
//                       getCity(value)
//                     }}
//                   />
//                 )}
//               />
//             </Col>
//             <Col column="col-md-2">
//               <Controller
//                 control={control}
//                 name="idcidade"
//                 render={({ field }) => (
//                   <SelectLabel
//                     field={field}
//                     text="Cidade"
//                     error={errors?.idcidade?.message}
//                     register={register("idcidade")}
//                     options={cidade}
//                     onChange={(value, date) => {
//                       field.onChange(value);
//                       // getLojista(value)
//                     }}
//                   />
//                 )}
//               />
//             </Col>
//             {/* {lojista.length>0&&(<Col column="col-md-4">
//               <Controller
//                 control={control}
//                 name="idlojista"
//                 render={({ field }) => (
//                   <SelectLabel
//                     field={field}
//                     text="Loja"
//                     // error={errors?.idcidade?.message}
//                     register={register("idlojista")}
//                     options={lojista}
//                     onChange={(value, date) => {
//                       field.onChange(value);
//                     }}
//                   />
//                 )}
//               />
//             </Col>)} */}
//           </Row>
//           {/* <Row>
//             <Col column="col-md-4">
//               <Input
//                 register={register("email")}
//                 text="E-mail"
//                 type="text"
//                 error={errors?.email?.message}
//               />
//             </Col>
//             <Col column="col-md-4">
//               <Input
//                 register={register("emailConfirmar")}
//                 text="Confirmar E-mail"
//                 type="text"
//                 error={errors?.emailConfirmar?.message}
//               />
//             </Col>
//           </Row> */}
//           {/* <Row>
//             <Col column="col-md-4">
//               <Input
//                 register={register("password")}
//                 text="Senha"
//                 type="password"
//                 error={errors?.password?.message}
//               />
//             </Col>
//             <Col column="col-md-4">
//               <Input
//                 register={register("senhaConfimar")}
//                 text="Confirmar Senha"
//                 type="password"
//                 error={errors?.senhaConfimar?.message}
//               />
//             </Col>
//           </Row> */}
//           <Row>
//             <Col column="col-md-4">
//               <InputCheck register={register("politica")} error={errors?.politica?.message}>
//                 Li e concordo com a <Style.linkPoliticy href="https://4bi-diogo.s3.us-east-2.amazonaws.com/Politica+de+Privacidade/POLÍTICA+DE+PRIVACIDADE.pdf" target="_blank">Política de privacidade</Style.linkPoliticy>
//               </InputCheck>
//             </Col>
//           </Row>
//         </Fieldset>
//         <Style.Actions>
//           <Button type="submit" disabled={isSubmitting}>
//             Salvar
//           </Button>
//         </Style.Actions>
//       </Form>
//     </Style.Content>
//   );
// };
